import React, { useState, useEffect } from 'react';8

import TrplsTable from '../../../common/TrplsTable/TrplsTable';

const MatchedDriversToOrder = ({
  data,
  jels,
  classes,
  orderPid,
  onHoverTable,
  nodeToHighlight,
  matchedDriverOids,
  shouldTableUpdate,
  PARSED_ORDER_TABLE_ID,
  MATCHING_DRIVER_TABLE_ID,
  MATCHED_DRIVER_PREDICATE_ID,
  VALID_MATCHING_PREDICATE_ID,
}) => {
  const [updateDrivers, setUpdateDrivers] = useState(false);

  useEffect(() => {
    if (updateDrivers) {
      setTimeout(() => {
        setUpdateDrivers(false);
      }, 500);
    }
  }, [updateDrivers]);

  return (
    <React.Fragment>
      <div style={{ marginTop: '-10px' }} className={`${classes.tableContainer}`}>
        <TrplsTable
          isEmbed
          customSTitle={'Orders'}
          smallHeadingBtns={true}
          preloadedData={
            {
              ...data,
              total_query: 1,
              query: [orderPid],
            }
          }
          updateFilter={{
            nodes: [orderPid],
          }}
          tableGroupIndex={orderPid + '-order'}
          settings={jels.jelData[PARSED_ORDER_TABLE_ID]}
          closeModalCb={() => setUpdateDrivers(true)}
        />
      </div>

      <div
        className={classes.tableContainer}
        onMouseEnter={() => onHoverTable(nodeToHighlight)}
      >
        <TrplsTable
          isEmbed
          whiteRows={true}
          smallHeadingBtns={true}
          customSTitle={'Drivers'}
          forceUpdateTable={updateDrivers || shouldTableUpdate}
          nodeToHighlight={nodeToHighlight}
          preloadedData={
            {
              ...data,
              total_query: matchedDriverOids.length,
              query: matchedDriverOids,
            }
          }
          updateFilter={{trpls: [{pids_chain: [MATCHED_DRIVER_PREDICATE_ID], val: orderPid}
                                  ,{pids_chain: [VALID_MATCHING_PREDICATE_ID], val: true}]}}
          tableGroupIndex={orderPid + '-drivers'}
          settings={jels.jelData[MATCHING_DRIVER_TABLE_ID]}
        />
      </div>
    </React.Fragment>
  )
};

export default MatchedDriversToOrder;
